<div class="nacha-wizard">
  <!-- Progress indicator -->
  <div class="wizard-progress">
    <div
      class="progress-step"
      [class.active]="currentStep >= NachaStep.UPLOAD"
      [class.completed]="currentStep > NachaStep.UPLOAD"
    >
      <div class="step-number">1</div>
      <div class="step-label">Upload</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > NachaStep.UPLOAD"></div>
    <div
      class="progress-step"
      [class.active]="currentStep >= NachaStep.REVIEW"
      [class.completed]="currentStep > NachaStep.REVIEW"
    >
      <div class="step-number">2</div>
      <div class="step-label">Review</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > NachaStep.REVIEW"></div>
    <div
      class="progress-step"
      [class.active]="currentStep >= NachaStep.PROCESS"
      [class.completed]="currentStep > NachaStep.PROCESS"
    >
      <div class="step-number">3</div>
      <div class="step-label">Process</div>
    </div>
    <div class="progress-line" [class.completed]="currentStep > NachaStep.PROCESS"></div>
    <div class="progress-step" [class.active]="currentStep >= NachaStep.RESULTS">
      <div class="step-number">4</div>
      <div class="step-label">Results</div>
    </div>
  </div>

  <!-- Step content -->
  <div class="wizard-content">
    <!-- Step 1: Upload -->
    @if (currentStep === NachaStep.UPLOAD) {
    <div class="step-container">
      <h3>Step 1: Upload NACHA File</h3>
      <p class="step-description">
        Upload your NACHA ACH file (.txt format). Customer matching uses the Individual ID Number field.
      </p>
      <app-nacha-upload-step
        [fileSummary]="parseResult?.summary ?? null"
        [parseErrors]="parseResult?.errors ?? []"
        [initialFileName]="uploadedFileName"
        (nachaUploaded)="onNachaUploaded($event)"
      ></app-nacha-upload-step>
    </div>
    }

    <!-- Step 2: Review -->
    @if (currentStep === NachaStep.REVIEW) {
    <div class="step-container">
      <h3>Step 2: Review & Match Customers</h3>
      <p class="step-description">
        Match each NACHA entry to a customer in your system. Use the checkboxes to choose which entries to process.
      </p>
      @if (isMatching) {
      <div class="loading-state">
        <mat-icon>hourglass_empty</mat-icon>
        <p>Matching customers...</p>
      </div>
      } @else {
      <app-nacha-review-step
        [matches]="matches"
        (toggleInclude)="onToggleInclude($event)"
        (addCustomer)="onAddCustomer($event)"
        (selectCustomer)="onSelectCustomer($event)"
        (addAllCustomers)="onAddAllCustomers()"
        (useNachaAccount)="onUseNacha($event)"
        (useFreelyAccount)="onUseFreely($event)"
        (updateFreelyAccount)="onUpdateFreely($event)"
        (saveAccountOnFile)="onSaveOnFile($event)"
        (applyToAllMismatches)="onApplyToAllMismatches($event)"
      ></app-nacha-review-step>
      }
    </div>
    }

    <!-- Step 3: Process -->
    @if (currentStep === NachaStep.PROCESS) {
    <div class="step-container">
      <h3>Step 3: Processing Payments</h3>
      <app-nacha-process-step
        [isProcessing]="isProcessing"
        [progress]="processingProgress"
        [totalCount]="includedCount"
      ></app-nacha-process-step>
    </div>
    }

    <!-- Step 4: Results -->
    @if (currentStep === NachaStep.RESULTS) {
    <div class="step-container">
      <h3>Step 4: Results</h3>
      <app-nacha-results-step
        [results]="results"
        [matches]="matches"
        (downloadResults)="downloadResults()"
        (viewReceipt)="viewReceipt($event)"
        (downloadReceipt)="downloadReceipt($event)"
      ></app-nacha-results-step>
    </div>
    }
  </div>

  <!-- Navigation actions -->
  <div class="wizard-actions">
    @if (currentStep === NachaStep.UPLOAD) {
    <button mat-raised-button color="primary" (click)="proceedToReview()" [disabled]="!canProceedToReview">
      Next: Review Matches
      <mat-icon>arrow_forward</mat-icon>
    </button>
    } @if (currentStep === NachaStep.REVIEW) {
    <button mat-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Back
    </button>
    <button mat-raised-button color="primary" (click)="proceedToProcess()" [disabled]="!canProceedToProcess">
      Process Payments ({{ includedCount }})
      <mat-icon>arrow_forward</mat-icon>
    </button>
    } @if (currentStep === NachaStep.RESULTS) {
    <button mat-button (click)="reset()">
      <mat-icon>refresh</mat-icon>
      Process Another File
    </button>
    <button mat-raised-button color="primary" (click)="downloadResults()">
      <mat-icon>download</mat-icon>
      Download Results
    </button>
    }
  </div>
</div>
